import { all, fork } from 'redux-saga/effects';
import watchFetchNotifications from './watchFetchNotifications';

export default function* watchNotifications() {
  yield all([fork(watchFetchNotifications)]);
}
